/**
 * Null physics clock
 *
 * This class is used when wasm intergrated physics is not used
 */
export class NullPhysicsClock {
    getDeltaTime() {
        return undefined;
    }
}
